"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransitionProps = exports.reflow = void 0;
var reflow = function (node) { return node.scrollTop; };
exports.reflow = reflow;
function getTransitionProps(props, options) {
    var _a, _b;
    var timeout = props.timeout, easing = props.easing, _c = props.style, style = _c === void 0 ? {} : _c;
    return {
        duration: (_a = style.transitionDuration) !== null && _a !== void 0 ? _a : (typeof timeout === 'number'
            ? timeout
            : typeof timeout === 'object'
                ? timeout[options.mode]
                : 0),
        easing: (_b = style.transitionTimingFunction) !== null && _b !== void 0 ? _b : (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay,
    };
}
exports.getTransitionProps = getTransitionProps;
//# sourceMappingURL=transitions.js.map